module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e8db9671e95c4c4530eea1528936b9e7.jpg";